import React from 'react';
import {
  DashboardShell,
  StatCards,
  DataTable,
  WalletCta,
  formatPoints,
} from './DashboardShared';

const InvestorTemplate = ({ data }) => {
  const cards = data.cards || {};

  return (
    <DashboardShell
      title={`${data.company.name} — My Position`}
      subtitle="Your earnings and standing in this company"
      data={data}
    >
      <StatCards
        items={[
          { label: 'Wallet balance', value: formatPoints(data.wallet_balance) },
          { label: 'Lifetime points', value: formatPoints(cards.lifetime_points) },
          { label: 'Points this month', value: formatPoints(cards.points_this_month) },
        ]}
      />

      <DataTable
        title="Recent commission credits"
        columns={[
          { key: 'date', label: 'Date', render: (row) => row.date?.split(' ')[0] ?? '—' },
          { key: 'product_name', label: 'Product' },
          { key: 'service_name', label: 'Sale type' },
          {
            key: 'amount',
            label: 'Points',
            render: (row) => `+${formatPoints(row.amount)}`,
          },
        ]}
        rows={data.recent_commissions || []}
        emptyMessage="No earnings in this company yet. Commissions appear when network sales are recorded."
      />

      <WalletCta />
    </DashboardShell>
  );
};

export default InvestorTemplate;
